import React from 'react';

import IMG_1 from '../../../Images/sliders/home/slider-gire.png';
import IMG_2 from '../../../Images/sliders/home/slide-souvenir.png';
import IMG_3 from '../../../Images/sliders/home/slide-mercedes.png';
import IMG_4 from '../../../Images/sliders/home/slider-lux.png';
import IMG_5 from '../../../Images/sliders/home/slider-popcorn.png';
import IMG_6 from '../../../Images/sliders/home/slider-torres.png';
import IMG_7 from '../../../Images/sliders/home/slider-interceramic.png';
import IMG_8 from '../../../Images/sliders/home/slider-mariodomm.png';
import IMG_9 from '../../../Images/sliders/home/slider-mexico86.png';

export const INTRO_TEXT = [
  {
    textSize: '2rem',
    textMobile: '1.25rem',
    renderContent: () => (
      <span>20 años contando historias… El siguiente capítulo ya empezó.</span>
    ),
    marginBottom: '0px',
  },
];

export const SLIDER_IMAGES = [
  {
    img: IMG_1,
    alt: 'Gire',
  },
  {
    img: IMG_2,
    alt: 'Souvenir',
  },
  {
    img: IMG_3,
    alt: 'Mercedes Benz',
  },
  {
    img: IMG_4,
    alt: 'Opticas Lux',
  },
  {
    img: IMG_5,
    alt: 'Popcorn',
  },
  {
    img: IMG_6,
    alt: 'Torres 10',
  },
  {
    img: IMG_7,
    alt: 'Interceramic',
  },
  {
    img: IMG_8,
    alt: 'Mario Domm',
  },
  {
    img: IMG_9,
    alt: 'Mexico 86',
  },
];
